import {
  ConversationMessage,
  ConversationMessageAttachment,
} from '@/types/conversationMessage';
import api from '@/api';

const CONVERSATIONS_PATH = 'conversations';
const MESSAGES_PATH = 'messages';

type SendMessageParams = {
  conversationId: string;
  body: string;
  sentFromBrandId: string;
};

type CreateAttachmentParams = {
  sourceId: string;
  fileName: string;
  mimeType: string;
};

const conversationMessagesUpdaters = {
  sendMessage: async (
    params: SendMessageParams
  ): Promise<ConversationMessage> => {
    const {conversationId, body, sentFromBrandId} = params;
    const result = await api.post(
      `${CONVERSATIONS_PATH}/${conversationId}/messages`,
      {
        body,
        sentFromBrandId,
      }
    );
    return result.data as ConversationMessage;
  },

  markRead: async (conversationId: string): Promise<void> => {
    await api.put(`${CONVERSATIONS_PATH}/${conversationId}/mark_read`);
  },

  markAllRead: async (conversationId: string): Promise<void> => {
    await api.put(`${CONVERSATIONS_PATH}/${conversationId}/mark_all_read`);
  },

  createAttachment: async (
    messageId: string,
    params: CreateAttachmentParams
  ): Promise<ConversationMessageAttachment> => {
    const result = await api.post(`${MESSAGES_PATH}/${messageId}/attachments`, {
      sourceId: params.sourceId,
      fileName: params.fileName,
      mimeType: params.mimeType,
    });
    return result.data as ConversationMessageAttachment;
  },

  markUnread: async (messageId: string): Promise<void> => {
    await api.put(`${MESSAGES_PATH}/${messageId}/mark_unread`);
  },
};

export default conversationMessagesUpdaters;
